import { useEffect, useState } from "react";
import { Clock, Loader2, RefreshCw, AlertTriangle, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { GuidaSezione } from "@/components/GuidaSezione";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "mai");
const oreFa = (iso) => (iso ? (Date.now() - new Date(iso).getTime()) / 36e5 : Infinity);

/** Cruscotto dei job programmati: ultimo passaggio del tick (ogni 15 min) e di ogni job smistato. */
export const CronBox = () => {
  const [d, setD] = useState(null);
  const carica = () => api.get("/admin/cron/stato").then((r) => setD(r.data)).catch(() => setD(false));
  useEffect(() => { carica(); }, []);
  if (d === null) return <div className="rounded-xl border border-slate-200 p-4 text-sm text-slate-500 flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> Attività programmate…</div>;
  if (!d) return null;
  const tickFermo = oreFa(d.ultimo_tick?.created_at) > 0.75;
  return (
    <div className="rounded-xl border border-slate-200 p-4" data-testid="cron-box">
      <GuidaSezione k="cron" passi={["La piattaforma chiama un solo «tick» ogni 15 minuti; il tick avvia ogni job interno all'orario previsto (ora di Roma). Se un orario è già passato nella giornata, il job recupera al primo tick utile.", "Rosso = il tick non passa da oltre 45 minuti (verifica il deploy) o un job già previsto oggi non è ancora partito; i job non ancora dovuti (orario futuro, altro giorno) restano neutri."]} />
      <div className="flex flex-wrap items-center gap-3">
        <Clock size={16} className="text-[#003087]" /><h4 className="font-medium text-slate-900">Attività programmate</h4>
        <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold inline-flex items-center gap-1 ${tickFermo ? "bg-red-50 text-red-700" : "bg-emerald-50 text-emerald-800"}`} data-testid="cron-ultimo-tick">
          {tickFermo ? <AlertTriangle size={12} /> : <CheckCircle2 size={12} />} ultimo tick: {fmt(d.ultimo_tick?.created_at)}
        </span>
        <Button size="sm" variant="ghost" onClick={carica} data-testid="cron-aggiorna"><RefreshCw size={14} /></Button>
      </div>
      <table className="w-full text-sm mt-3" data-testid="cron-tabella">
        <thead className="text-xs uppercase tracking-wider text-slate-500"><tr><th className="text-left py-1">Job</th><th className="text-left">Orario (Roma)</th><th className="text-left">Ultimo passaggio</th><th className="text-left">Esito</th></tr></thead>
        <tbody>
          {d.jobs.map((j) => {
            const vecchio = j.in_ritardo;
            return (
              <tr key={j.nome} className="border-t border-slate-100" data-testid={`cron-riga-${j.nome}`}>
                <td className="py-1.5 font-medium text-slate-900">{j.nome}</td>
                <td className="text-slate-600">{j.orario}</td>
                <td className={`tabular-nums ${vecchio ? "text-red-600" : "text-slate-700"}`}>{j.ultimo ? fmt(j.ultimo) : (vecchio ? "non ancora partito" : "non previsto finora")}</td>
                <td className="text-xs text-slate-500 max-w-[320px] truncate" title={j.esito ? JSON.stringify(j.esito) : ""}>{j.ultimo ? (j.finito ? (j.esito ? JSON.stringify(j.esito).slice(0, 80) : "ok") : "in corso…") : "—"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
